"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _NodingValidator = _interopRequireDefault(require("../NodingValidator"));

var _hasInterface = _interopRequireDefault(require("../../../../../hasInterface"));

var _Collection = _interopRequireDefault(require("../../../../../java/util/Collection"));

var _Noder = _interopRequireDefault(require("../Noder"));

var _MCIndexNoder = _interopRequireDefault(require("../MCIndexNoder"));

var _NodedSegmentString = _interopRequireDefault(require("../NodedSegmentString"));

var _HotPixel = _interopRequireDefault(require("./HotPixel"));

var _Exception = _interopRequireDefault(require("../../../../../java/lang/Exception"));

var _MCIndexPointSnapper = _interopRequireDefault(require("./MCIndexPointSnapper"));

var _RobustLineIntersector = _interopRequireDefault(require("../../algorithm/RobustLineIntersector"));

var _InteriorIntersectionFinderAdder = _interopRequireDefault(require("../InteriorIntersectionFinderAdder"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var MCIndexSnapRounder =
/*#__PURE__*/
function () {
  function MCIndexSnapRounder() {
    _classCallCheck(this, MCIndexSnapRounder);

    MCIndexSnapRounder.constructor_.apply(this, arguments);
  }

  _createClass(MCIndexSnapRounder, [{
    key: "checkCorrectness",
    value: function checkCorrectness(inputSegmentStrings) {
      var resultSegStrings = _NodedSegmentString.default.getNodedSubstrings(inputSegmentStrings);

      var nv = new _NodingValidator.default(resultSegStrings);

      try {
        nv.checkValid();
      } catch (ex) {
        if (ex instanceof _Exception.default) {
          ex.printStackTrace();
        } else throw ex;
      } finally {}
    }
  }, {
    key: "getNodedSubstrings",
    value: function getNodedSubstrings() {
      return _NodedSegmentString.default.getNodedSubstrings(this._nodedSegStrings);
    }
  }, {
    key: "snapRound",
    value: function snapRound(segStrings, li) {
      var intersections = this.findInteriorIntersections(segStrings, li);
      this.computeIntersectionSnaps(intersections);
      this.computeVertexSnaps(segStrings);
    }
  }, {
    key: "findInteriorIntersections",
    value: function findInteriorIntersections(segStrings, li) {
      var intFinderAdder = new _InteriorIntersectionFinderAdder.default(li);

      this._noder.setSegmentIntersector(intFinderAdder);

      this._noder.computeNodes(segStrings);

      return intFinderAdder.getInteriorIntersections();
    }
  }, {
    key: "computeVertexSnaps",
    value: function computeVertexSnaps() {
      if ((0, _hasInterface.default)(arguments[0], _Collection.default)) {
        var edges = arguments[0];

        for (var i0 = edges.iterator(); i0.hasNext();) {
          var edge0 = i0.next();
          this.computeVertexSnaps(edge0);
        }
      } else if (arguments[0] instanceof _NodedSegmentString.default) {
        var e = arguments[0];
        var pts0 = e.getCoordinates();

        for (var i = 0; i < pts0.length; i++) {
          var hotPixel = new _HotPixel.default(pts0[i], this._scaleFactor, this._li);

          var isNodeAdded = this._pointSnapper.snap(hotPixel, e, i);

          if (isNodeAdded) {
            e.addIntersection(pts0[i], i);
          }
        }
      }
    }
  }, {
    key: "computeNodes",
    value: function computeNodes(inputSegmentStrings) {
      this._nodedSegStrings = inputSegmentStrings;
      this._noder = new _MCIndexNoder.default();
      this._pointSnapper = new _MCIndexPointSnapper.default(this._noder.getIndex());
      this.snapRound(inputSegmentStrings, this._li);
    }
  }, {
    key: "computeIntersectionSnaps",
    value: function computeIntersectionSnaps(snapPts) {
      for (var it = snapPts.iterator(); it.hasNext();) {
        var snapPt = it.next();
        var hotPixel = new _HotPixel.default(snapPt, this._scaleFactor, this._li);

        this._pointSnapper.snap(hotPixel);
      }
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return MCIndexSnapRounder;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [_Noder.default];
    }
  }]);

  return MCIndexSnapRounder;
}();

exports.default = MCIndexSnapRounder;

MCIndexSnapRounder.constructor_ = function () {
  this._pm = null;
  this._li = null;
  this._scaleFactor = null;
  this._noder = null;
  this._pointSnapper = null;
  this._nodedSegStrings = null;
  var pm = arguments[0];
  this._pm = pm;
  this._li = new _RobustLineIntersector.default();

  this._li.setPrecisionModel(pm);

  this._scaleFactor = pm.getScale();
};